import publicaFederal from "../assets/publicar-federal.png";
import publicaEstadual from "../assets/publicar-estadual.png";
import particularMunicipal from "../assets/particular-municipal.png";
import particularPrivado from "../assets/particular-privado.png";
import {
  PUBLICA_VALUE,
  PUBLICA_ESFERAS,
  DEFAULT_ESFERA_PRIVADA,
  getEsferaDisplayValue,
} from "./naturezaJuridica";

/**.
 *
 * @param {Object} params
 * @param {string} params.naturezaJuridica
 * @param {string} params.esfera
 * @returns {string | null}
 */
export function getInstituicaoLogo({ naturezaJuridica, esfera } = {}) {
  if (!naturezaJuridica && !esfera) return null;

  const normalizedEsfera = getEsferaDisplayValue(
    naturezaJuridica,
    esfera || DEFAULT_ESFERA_PRIVADA
  );

  // Instituições públicas
  if (naturezaJuridica === PUBLICA_VALUE) {
    if (normalizedEsfera === "Federal") {
      return publicaFederal;
    }

    // Para pública estadual / municipal usamos o mesmo conjunto visual
    if (PUBLICA_ESFERAS.includes(normalizedEsfera)) {
      return publicaEstadual;
    }
  }

  // Instituições privadas
  if (normalizedEsfera === "Municipal") {
    return particularMunicipal;
  }

  return particularPrivado;
}


